import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const CarpetasDigitales = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const years = [
    { year: 2022, to: '/ControlInterno/CarpetasDigitales/2022' },
    { year: 2023, to: '#' },
    { year: 2024, to: '#' },
    { year: 2025, to: '#' },
  ];

  const categories = [
    { label: 'Primera Sesión Ordinaria', bgColor: '#691C32' },
    { label: 'Segunda Sesión Ordinaria', bgColor: '#8F345A' },
    { label: 'Tercera Sesión Ordinaria', bgColor: '#B9859A' },
    { label: 'Cuarta Sesión Ordinaria', bgColor: '#A89968' },
    { label: 'Reuniones de Trabajo',     bgColor: '#6DA3BD' },
    { label: 'Capacitaciones',           bgColor: '#746666' },
    { label: 'Control Interno',          bgColor: '#6F5400' },
    { label: 'Administración de Riesgos',bgColor: '#7F7817' },
  ];

  return (
    <>
      <HeaderSCI title="CARPETAS DIGITALES Y EVIDENCIAS" />

      <div className="container" style={{ paddingBottom: '60px' }}>
        <div className="row justify-content-center">
          {years.map((y, yIdx) => (
            <div key={yIdx} className="col-lg-3 col-md-6 col-12 mb-5 d-flex flex-column align-items-center">
              {/* Year Icon Header */}
              <Link to={y.to} className="carpetas-year-header-link">
                <div className="carpetas-year-header">
                  <div className="carpetas-year-icon">
                    <i className="fa-regular fa-address-card"></i>
                  </div>
                  <h4 className="carpetas-year-title">Año {y.year}</h4>
                </div>
              </Link>

              {/* List of categories */}
              <div className="w-100 d-flex flex-column align-items-center">
                {categories.map((c, cIdx) => (
                  <Link
                    key={cIdx}
                    to={y.to}
                    className="carpetas-category-btn"
                    style={{ backgroundColor: c.bgColor }}
                  >
                    {c.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CarpetasDigitales;
